<template>
  <BaseSidebar
    :model-value="isPanelOpen"
    title="Novidades"
    description="O que mudou nas últimas versões do Minha Escala."
    :icon="mdiBullhornOutline"
    @update:model-value="onUpdateOpen"
  >
    <div class="flex flex-col gap-6 pb-4">
      <ChangelogEntry v-for="entry in recentEntries" :key="entry.version" :entry="entry" />
    </div>

    <template #footer>
      <OutlineButton
        text="Ver todas as novidades"
        width="100%"
        height="46px"
        data-testid="changelog-see-all-link"
        @click="goToChangelogPage"
      />
    </template>
  </BaseSidebar>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { mdiBullhornOutline } from '@mdi/js'

import { useChangelog } from '@/hooks/useChangelog'
import PATHS from '@/router/paths'
import BaseSidebar from '@/components/designSystem/Sidebar/BaseSidebar.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import ChangelogEntry from '@/components/Changelog/ChangelogEntry.vue'

const RECENT_ENTRIES_LIMIT = 5

const router = useRouter()
const { entries, isPanelOpen, closePanel } = useChangelog()

const recentEntries = computed(() => entries.value.slice(0, RECENT_ENTRIES_LIMIT))

function onUpdateOpen(value: boolean) {
  if (!value) closePanel()
}

function goToChangelogPage() {
  closePanel()
  router.push(PATHS.CHANGELOG)
}
</script>
